import React from 'react'

import type { ISiteSpecificInitialValue } from '@/contexts/SiteSpecificContext'

import { SiteSpecificContextProvider } from '@/contexts/SiteSpecificContext'
import DynamicAccountDevTool from '@/pages/tad.ai/_components/DynamicAccountDevTool'

export interface ISiteSpecificContextLayoutProps {
  children: React.ReactNode
  value?: ISiteSpecificInitialValue
}

/**
 * 站点特有的全局状态管理 Layout
 */
const SiteSpecificContextLayout: React.FC<ISiteSpecificContextLayoutProps> = (
  props,
) => {
  const { children, value } = props

  return (
    <SiteSpecificContextProvider initialValue={value}>
      <DynamicAccountDevTool />
      {children}
    </SiteSpecificContextProvider>
  )
}

export default SiteSpecificContextLayout
